import { type JSX } from 'react';

import { fmtCps, fmtCpsTarget } from '@/components/ops/format';
import { cn } from '@/lib/utils';

// CpsValue shows the actual CPS prominently with a muted "/target"; amber when
// the caller says so (concurrency-capped or dialing far under target). The
// caller also decides the tooltip — e.g. the concurrency warning when capped,
// or a "stalled" hint at 0 CPS.
export function CpsValue({
  current,
  target,
  amber,
  title,
}: {
  current: number;
  target: number;
  amber: boolean;
  title?: string;
}): JSX.Element {
  const targetText = fmtCpsTarget(target);
  return (
    <span className="inline-flex items-baseline gap-1 justify-end tabular-nums" title={title}>
      <span className={cn('text-[15px] font-semibold', amber ? 'text-warn' : 'text-text')}>{fmtCps(current)}</span>
      {targetText && <span className="text-[11px] text-text-4 font-medium">/{targetText}</span>}
    </span>
  );
}
